import { useParams } from 'react-router-dom';
import { useGetEquipmentDetails } from 'hooks/useEquipment';

export function EquipmentBreadcrumb() {
  const { equipmentId = '' } = useParams();
  const { equipment } = useGetEquipmentDetails(equipmentId);

  return equipment?.name ?? equipmentId;
}
